import React from 'react';
import { useIntl } from 'umi';
import { StatusTip } from 'tea-component';
import styles from './index.module.scss';

interface IProps {
  marginTop?: string;
  content?: string | React.ReactNode;
}

export default function App(props: IProps) {
  const {formatMessage } = useIntl();
  const {  marginTop='0', content=formatMessage({ id: 'common_loading'})} = props;
  return (
    <div className={styles.box}>
      <StatusTip status="loading" loadingText={content} style={{marginTop}}/>
    </div>
  );
}
